const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

// Write a SheetJS workbook to an .xlsx file and trigger a browser download via
// the Blob + anchor path. We avoid XLSX.writeFile because it can silently
// no-op in some bundler/browser environments, leaving the user with a button
// that appears to do nothing. Callers pass the same xlsx module they used to
// build the workbook so it stays lazily code-split out of the main bundle.
export function downloadXlsx(
  xlsx: typeof import('xlsx'),
  workbook: import('xlsx').WorkBook,
  filename: string,
): void {
  const buf = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' }) as ArrayBuffer
  const blob = new Blob([buf], { type: XLSX_MIME })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
